import { render, staticRenderFns } from "./single-agent-transactions.vue?vue&type=template&id=01489774"
import script from "./single-agent-transactions.vue?vue&type=script&lang=js"
export * from "./single-agent-transactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports